<template>
  <div class="modal fade" id="confirm-stop-use-warehouse-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <p>この倉庫の利用を停止してもよろしいですか？</p>
          <div>
            <div class="notes">ご注意事項</div>
            <ul class="notes-content">
              <li>
                STOCKCREW倉庫に在庫がある場合、セラー様へご送付させていただきます。<br>
                （送料、費用についてはセラー様負担となります）
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal" @click="$emit('confirm')">利用を停止する</button>
          <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    $('#confirm-stop-use-warehouse-modal').modal('show')
    $('#confirm-stop-use-warehouse-modal').on('hidden.bs.modal', (e) => {
      if (!$('#myModal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouses/ConfirmStopUseModal.vue